import { useMutation } from '@apollo/client';
import { removeDemographicAudienceInsightMutation } from 'api/mutations/customInsight';

type DeleteCustomInsightResponse = {
  removeDemographicAudienceInsight: { success: boolean };
};

type DeleteCustomInsightRequest = {
  contactProperty: string;
};

export const useDeleteCustomDemographicInsight = () => {
  const [deleteDemographicAudienceInsight, { data, loading, called, error }] = useMutation<
    DeleteCustomInsightResponse,
    DeleteCustomInsightRequest
  >(removeDemographicAudienceInsightMutation);

  const deleteCustomDemographicInsight = (contactProperty: string) => {
    deleteDemographicAudienceInsight({ variables: { contactProperty } });
  };

  return {
    deleteCustomDemographicInsight,
    data: data ?? null,
    isLoading: loading,
    isCalled: called,
    isSuccess: !loading && !!data?.removeDemographicAudienceInsight.success,
    isError: !loading && (!data?.removeDemographicAudienceInsight.success || !!error),
  };
};
